import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=32871581"
import script from "./WhatsappIcon.vue?vue&type=script&lang=ts"
export * from "./WhatsappIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports